import * as moment from "moment";

export class CandidateModel {
  private candidate: CandidateModel;
  id: number;
  employers_id: number;
  users_id: number;
  viewed: boolean;
  created_at: string;
  updated_at: string;
  User: UserModel;

  constructor(inputCandidate: CandidateModel) {
    this.candidate = inputCandidate;
  }

  get fullName(): string {
    return `${this.candidate.User.name} ${this.candidate.User.surname}`;
  }

  get status(): string {
    return `${this.candidate.User.status}`;
  }

  get birthdate() {
    return this.candidate.User.birthdate;
  }

  get years() {
    return moment().diff(this.birthdate, "years");
  }

  get mail() {
    return (
      this.candidate.User.contact_email || this.candidate.User.email || "-"
    );
  }

  get phone() {
    return (
      this.candidate.User.contact_phone || this.candidate.User.phone || "-"
    );
  }

  get address() {
    return this.candidate.User.contact_address || "-";
  }

  get profileImage(): string {
    return this.candidate.User.img || `assets/img/avatar-orange.png`;
  }

  get notViewed(): boolean {
    return !this.candidate.viewed;
  }

  get userId(): number {
    return this.candidate.User.id;
  }

  get educations(): EducationDataModel[] {
    let educations: EducationDataModel[] = [];
    this.candidate.User.AcademicQualifications.forEach((edu) => {
      let education = new EducationDataModel();
      education.macroStudyTag = edu.StudyTag.MacroStudyTag.name_en;
      education.studyTag = edu.StudyTag.name_en;
      education.course = edu.course_name;
      education.university = edu.university_name;
      education.graduationLabel = edu.finished_at
        ? "graduation"
        : "expected graduation";
      education.graduationDate = edu.finished_at
        ? new Date(edu.finished_at)
        : new Date(edu.expected_finished_at);
      education.voteLabel = edu.vote ? "vote" : "average";
      education.vote = edu.vote
        ? String(edu.vote)
        : edu.avg
          ? String(edu.avg)
          : "-";
      education.qualification = edu.qualification_name;
      education.isCompleted = edu.courses_id !== null;
      education.noVoteNoAvg = edu.vote === null && edu.avg === null;
      educations.push(education);
    });
    return educations;
  }

  get jobOffers() {
    return this.candidate.User.UserJobs;
  }

  // private educationData
}

export class EducationDataModel {
  macroStudyTag: string;
  studyTag: string;
  course: string;
  university: string;
  qualification: string;
  graduationLabel: string;
  graduationDate: Date;
  voteLabel: string;
  vote: string;
  isCompleted: boolean;
  noVoteNoAvg: boolean;

  constructor() {
    this.macroStudyTag = null;
    this.studyTag = null;
    this.course = null;
    this.university = null;
    this.graduationLabel = null;
    this.graduationDate = null;
    this.voteLabel = null;
    this.vote = null;
    this.qualification = null;
    this.isCompleted = false;
    this.noVoteNoAvg = false;
  }
}

export class UserModel {
  id: number;
  name: string;
  surname: string;
  slug?: null;
  img?: null;
  has_default_placeholder: boolean;
  email: string;
  email_verified: boolean;
  blocked: boolean;
  community: boolean;
  corporate: boolean;
  view: boolean;
  phone?: null;
  password: string;
  role: string;
  revoked_tokens?: null;
  seed: string;
  reset_pwd?: null;
  courses_id: number;
  contact_email: string;
  contact_phone: string;
  contact_address: string;
  birthdate: string;
  avg?: null;
  plan?: null;
  status: string;
  language: string;
  subscribed_email: boolean;
  subscribed_push: boolean;
  created_at: string;
  updated_at: string;
  Course: CourseModel;
  UserJobs?: UserJobsEntityModel[] | null;
  AcademicQualifications?: AcademicQualificationsEntityModel[] | null;
  UserLanguages?: UserLanguagesEntityModel[] | null;
  geolocation: {
    id: number;
    formattedName: string;
  };
}
export class CourseModel {
  id: number;
  name: string;
  tag: string;
  tag_2?: null;
  tag_3?: null;
  view: boolean;
  created_at: string;
  updated_at: string;
  faculties_id?: null;
  qualifications_id: number;
  UniversityCourseView: UniversityCourseViewModel;
}
export class UniversityCourseViewModel {
  country_id: number;
  country_name: string;
  country_tag: string;
  city_id: number;
  city_name: string;
  city_tag: string;
  university_id: number;
  university_name: string;
  university_img?: null;
  university_tag: string;
  faculty_id: number;
  faculty_name: string;
  faculty_tag: string;
  course_id: number;
  course_name: string;
  course_tag: string;
  course_tag_2?: null;
  course_tag_3?: null;
}

export class UserJobsEntityModel {
  story_url?: null;
  id: number;
  status: string;
  process_status: string;
  comment?: string;
  applied_at: string;
  Tags?: TagsEntity[] | null;
  JobOffer: JobOfferModel;
}
export class TagsEntity {
  id: number;
  name: string;
  application_has_tags: ApplicationHasTags;
}
export class ApplicationHasTags {
  created_at: string;
  updated_at: string;
  application_id: number;
  tag_id: number;
}
export class JobOfferModel {
  id: number;
  job_id?: number;
  position: string;
}

export class AcademicQualificationsEntityModel {
  id: number;
  universities_id: number;
  cities_id: number;
  university_tag: string;
  university_name: string;
  faculty_name?: string;
  faculties_id?: null;
  course_name: string;
  courses_id: number;
  study_tags_id: number;
  users_id: number;
  qualification_name: string;
  qualifications_id: number;
  started_at: string;
  finished_at: string;
  expected_finished_at?: null;
  vote: number;
  normalized_vote: number;
  normalized_avg?: null;
  year?: null;
  view: boolean;
  is_current: boolean;
  avg?: null;
  status: string;
  manage_graduation_vote: boolean;
  index: number;
  is_post_graduate: boolean;
  StudyTag: StudyTagModel;
  City: CityModel;
}

export class CityModel {
  id: number;
  name: string;
  view: boolean;
  tag: string;
  lat: number;
  lng: number;
  population: number;
  created_at: string;
  updated_at: string;
  countries_id: number;
}

export class StudyTagModel {
  id: number;
  tag: string;
  name_it: string;
  name_en: string;
  name_es: string;
  name_fr: string;
  macro_study_tags_id: number;
  created_at: string;
  updated_at: string;
  MacroStudyTag: MacroStudyTagModel;
}
export class MacroStudyTagModel {
  id: number;
  tag: string;
  name_it: string;
  name_fr: string;
  name_en: string;
  name_es: string;
  created_at: string;
  updated_at: string;
}
export class UserLanguagesEntityModel {
  id: number;
  languages_id: number;
  index: number;
  view: boolean;
  users_id: number;
  language_levels_id: number;
}
